import React, { useState } from 'react';
import { Box, Toolbar, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import Header from './Header';
import Sidebar from './Sidebar';
import { ChatProvider } from '../../contexts/ChatContext';

export default function MainLayout({ children }) {
  const theme = useTheme();
  // En el movil el menu no cabe fijo al lado del contenido: se despliega encima
  const mobile = useMediaQuery(theme.breakpoints.down('md'));
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const toggle = () => setSidebarOpen((v) => !v);

  return (
    <ChatProvider>
      <Box sx={{ display: 'flex' }}>
        <Header onToggle={toggle} />
        <Sidebar open={sidebarOpen} mobile={mobile} onClose={() => setSidebarOpen(false)} />
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: { xs: 1.5, md: 3 },
            ml: 0,
            transition: 'margin 0.2s',
            minWidth: 0,
          }}
        >
          <Toolbar />
          {children}
        </Box>
      </Box>
    </ChatProvider>
  );
}
